const React = require("react");
const { useStaticQuery, graphql } = require("gatsby");

module.exports = function useResearchPages() {
  const { allNodePage } = useStaticQuery(
    graphql`query AllPages {
      allNodePage {
        totalCount
        edges {
          node {
            ...BasicPageCard
            field_research_page
          }
        }
      }
    }`
  );

  return allNodePage.edges
    .filter((edge) => edge.node.field_research_page === true)
    .map((edge) => ({
      ...edge.node,
    }));
}